import eventBus from '@/components/utils/slideout-panel/eventBus';

const BaseContextMenuMixin = {
  data() {
    return {
      show: false,
    };
  },
  methods: {
    toggleContextMenu() {
      this.show = !this.show;
    },
    showContextMenu() {
      this.show = true;
    },
    hideContextMenu() {
      this.show = false;
    },
  },
  created() {
    eventBus.$on('toggleContextMenu', this.toggleContextMenu);
  },
  destroyed() {
  },
};

export default BaseContextMenuMixin;
